// contacts
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import { UserForm } from "../services/srvc-utilities";

import ContactsAddModule from '../content/contacts/contacts-add';

export default function ContactsAdd() {


    return (
      <ContentFormatXX 
      head={'Add Contact'}
      link={`/${UserForm()}/home`}
      form={'small'}
      data={
        <>
          <WebbDividerSmall />
          <ContactsAddModule />
        </>
        
        }  
      /> 
    )
  }